import { addsymbolstobasketModal } from './../addsymbolstobasket/addsymbolstobasket.component';
import { Component, OnInit, Injector } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {Providers} from '../../../enums/providers';

@Component({
  selector: 'mobile-add-symbol-to-basket',
  template: require('./mobile-add-symbol-to-basket.component.html'),
  styles: [require('./mobile-add-symbol-to-basket.component.css')]
})
export class MobileAddSymbolToBasketComponent extends addsymbolstobasketModal 
{

  constructor(injector: Injector, public activeModal: NgbActiveModal) 
  {
    super(injector, activeModal);
  }

  ngAfterViewInit()
  {
    
  }

  updateCheckedSymbolsList(item: string, event: any) {
    if (event == true) {
        let index = this.symbolsList.indexOf(item);
        if (index < 0) {
            this.symbolsList.push(item);
        }
    } else {
        let index = this.symbolsList.indexOf(item);
        if (index >= -1) {
            this.symbolsList.splice(index, 1);
        }
    }
}


get horizontal()
{
  return this.workspace.horizontalMode;
}

public updateBasketView(e:any)
{
 // alert("RUN UPDATE")

 let list = Object.assign([], this.workspace.Baskets[this.workspace.activeBasket].items);
 //this.workspace.loadedSymbolsTypeSplit;


 //this.workspace.activeBasket
  this.symbolsList = list;

  //this.workspace.loadedSymbolsTypeSplit
  this.symbols = Object.assign({}, this.workspace.loadedSymbolsTypeSplit);
 
  this.symbols.forex.filter(l=>{

    if(this.workspace.competitionAccountList.indexOf(this.workspace.activeAccountIdBySet)>-1 || this.workspace.currentProvider!=Providers.DEMO)
    {
    // console.log(this.workspace.currentTournaments[0].tournamentAssets);
        if(this.workspace.allowedForexSymbols.indexOf(l)>-1)//&& this.workspace.currentTournaments[0].tournamentAssets.Assets.indexOf(0))
        {
            return true;
        }
        else
        {
            return false;
        }
    }
    else
    {
        return true;
    };
  });

}


}
